/**
 * triggers a download of a file by creating and clicking a temporary link element
 */
export const triggerLinkDownload = (
  downloadLink: string,
  fileName: string,
): void => {
  const link = document.createElement('a');
  link.href = downloadLink;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
